// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Actividad',
    ai: 'IA',
    ai_analyzing: 'Analizando patrones',
    ai_building: 'Construyendo modelo de previsión',
    ai_description: 'El {brandName} Pronóstico IA utiliza algoritmos de Aprendizaje Automático para encontrar patrones y relaciones entre eventos y acciones mediante el procesamiento de los datos históricos de su cuenta. Como resultado, mostrará la fecha de finalización del proyecto más probable y su confianza en esta predicción.',
    ai_forecast: 'Pronóstico AI',
    ai_forecast_date: 'Fecha de finalización del proyecto prevista por IA',
    ai_how_works: 'Más información sobre cómo funciona IA',
    ai_not_enough_data: 'No hay suficientes datos históricos para hacer un pronóstico confiable. El Uso activo del sistema garantizará pronósticos más precisos. <a href=\"{0}\" target=\"_blank\" class=\"{1}\">Obtén más información</a> sobre AI Forecast.',
    ai_planned_date: 'Fecha de finalización prevista del proyecto',
    ai_result: 'Resultados de Pronóstico de IA',
    ai_reviewing: 'Revisión de datos históricos',
    apply: 'Aplicar',
    available: 'Disponible',
    back: 'Atrás',
    CanChangeWorkflowForProjectOutdatedData: 'El Flujo de Trabajo ya está aplicado para el proyecto. Actualice la página para actualizar los datos.',
    CanDeleteCategoryHasTask: 'Es imposible eliminar una categoría que se usa en las actividades.',
    CanDeletePriorityHasProject: 'No se puede eliminar una prioridad que se usa en los proyectos.',
    CanDeletePriorityHasTask: 'Es imposible eliminar una prioridad que se usa en las actividades.',
    CanDeletePriorityIsInternal: 'Es imposible eliminar una prioridad interna del sistema.',
    CanDeleteStatusIsWorkflowTypeStatus: 'Es imposible eliminar el estado predeterminado.',
    CanDeleteStatusUsed: 'Es imposible eliminar el estado que se utiliza en cualquier entidad.',
    CanDeleteThresholdIsInternal: 'Es imposible eliminar el umbral interno del sistema.',
    CanDeleteVacationTypeDefault: 'Es imposible eliminar el tipo de vacaciones por defecto.',
    CanDeleteVacationTypeHasVacation: 'Es imposible eliminar un tipo de vacaciones que tiene vacaciones asignadas.',
    CanDeleteWorkflowIsSingle: 'Debe haber al menos un flujo de trabajo en el sistema.',
    CanDeleteWorkflowIsUsed: 'Es imposible eliminar el flujo de trabajo que se utiliza en los proyectos.',
    CanDisableStatusIsUsed: 'Es imposible deshabilitar el estado que se usa en la entidad',
    CanDisableStatusIsWorkflowTypeStatus: 'Es imposible desactivar el estado predeterminado',
    CanEdit_Task_AccessDenied: 'No tiene permisos para editar esta actividad',
    CanEditValueThresholdIsInternal: 'Los valores umbral del presente sistema no se pueden alterar.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'Es imposible marcar el estado como predeterminado para el estado ya predeterminado.',
    change: 'cambiar',
    ChangeProjectProgressError: 'El progreso de un proyecto con tareas no se puede editar.',
    ChangeTaskProgressError: 'El progreso de una tarea principal no se puede editar.',
    Copy_Text: 'Copiar',
    copyPostfix: 'Copiar',
    description_title: 'Descripción',
    Edit_Text: 'Editar',
    empty_list: 'No se han encontrado resultados que coincidan con la consulta de búsqueda/filtro aplicado',
    error_reload: '{brandName} la versión ha sido actualizada. Para el correcto funcionamiento de la aplicación, es necesario volver a cargar la página.',
    export_csv: 'Exportar a CSV',
    export_pdf: 'Exportar a PDF',
    filters: 'Filtros',
    freeze: 'Columna de congelación',
    from: 'De',
    general: 'General',
    global_search_text: 'Buscar mensajes, archivos y más',
    GotIt: 'Lo tengo',
    here: 'aquí',
    in: 'en',
    in_use: 'En uso',
    label_custom_date_range: 'Intervalo de fechas personalizado',
    label_daily: 'Diario',
    label_monthly: 'Mensual',
    label_weekly: 'Semanal',
    least_likely: 'Menos Probable',
    month: 'Mes',
    MoreActions: 'Más acciones',
    most_likely: 'Lo más Probable',
    name_title: 'Nombre',
    next_month: 'Mes siguiente',
    next_week: 'Semana siguiente',
    no: 'No',
    no_available_filters: 'No hay valores disponibles para el filtro',
    no_data_to_display: 'Sin datos para mostrar',
    NoPermissionToArchiveProject: 'La acción solicitada (archivar proyecto) no está disponible por el siguiente motivo: No tiene permisos para archivar proyecto.',
    not_calculated: 'No calculado',
    not_in_use: 'No en uso',
    PortfolioLimitError: 'Ha alcanzado el límite de 60 carteras en Team Edition. Actualice a la {brandName} edición Enterprise.',
    previous_month: 'Mes anterior',
    previous_week: 'Semana anterior',
    previous_year: 'Año anterior',
    quarter: 'Trimestre',
    quick_search_placeholder: 'Escriba para buscar por nombre o ID',
    read_more: 'Leer más.',
    RecordConversionToActivityDifferentWorkflows: 'Es imposible convertir el registro, ya que se han aplicado diferentes flujos de trabajo al proyecto y a la plantilla.',
    role: 'Rol',
    select: 'Seleccionar',
    short_quarter0: 'T1',
    short_quarter1: 'T2',
    short_quarter2: 'T3',
    short_quarter3: 'T4',
    show_template: 'Mostrar: {0}',
    sort: 'Ordenar',
    sort_activities: 'Ordenar Actividades por:',
    sort_ascending: 'Ordenar ascendente',
    sort_az: 'Ordenar A→Z',
    sort_descending: 'Ordenar descendente',
    sort_projects: 'Ordenar Proyectos por:',
    sort_za: 'Ordenar Z→A',
    start_analyze: 'Iniciar Análisis',
    sub_features_list_title: 'Esta característica incluye:',
    SystemTaskCreatorName: 'Sistema',
    Task_CanAccessBillingInformation_AccessDenied: 'No tienes permisos para editar la configuración de facturación de esta actividad',
    this_month: 'Este mes',
    this_week: 'Esta semana',
    this_year: 'Este año',
    ThresholdValueDuplicate: 'Este valor umbral ya se ha añadido.',
    to: 'A',
    today: 'Hoy',
    unfreeze: 'Descongelar columna',
    UnknownErrorMessage: 'Lo siento, algo salió mal... Por favor, actualice la página.',
    upgrade: 'Actualizar',
    upgrade_to_enterprise: 'Actualización a Enterprise',
    week: 'Semana',
    WindowUnload_UnsavedChanges: 'Hay cambios no guardados. Estás seguro de que te gustaría dejar esta página?',
    year: 'Año',
    yes: 'Sí',
    yesterday: 'Ayer',
};
